import { Modal as AModal, Card, Spin } from 'antd';

import LoadingIndicator from 'components/LoadingIndicator';
import { Viewport } from 'components/ViewportProvider';
import messages from 'containers/OrdersPage/messages';
import moment from 'moment';
import React, { lazy, Suspense } from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import translations from 'translations';
import media from 'utils/mediaStyle';
import utilsMessages from 'utils/messages';
import LegacyDesktopTable from './LegacyDesktopTable';
import LegacyMobileTable from './LegacyMobileTable';
import LegacyOrderSummary from './LegacyOrderSummary';
const LazyModal = lazy(() => import('antd').then((module) => ({ default: module.Modal })));

const Container = styled.section``;
const TableContainer = styled.div`
  .ant-table-body table {
    display: flex;
    flex-direction: column;
    th {
      text-transform: capitalize;
    }
  }
  .ant-table-body .ant-table-row {
    display: block;
    width: 100%;
  }
  .ant-table-row td {
    display: block;
    width: 100%;
  }
  ${media.sm`
    .ant-table-body table {
      display: table;
      flex-direction: column;
    }
    .ant-table-body .ant-table-row {
      display: table-row;
    }
    .ant-table-row td {
      display: table-cell;
      width: 0;
    }
  `};
`;

interface OrderProps {
  order: any;
  onCancelOrder: (value: any) => void;
  onApproveOrder: (value: any) => void;
  onDisapproveOrder: (value: any) => void;
  onConfirmOrder: (value: any) => void;
  onReOrderAll: (value: any) => void;
  onUpdateDelivery: (value: any) => void;
  onPrintOrderInvoice: (value: string) => void;
  onEditOrder: () => void;
  intl: any;
  permissions: string[];
  isStatusChange?: boolean;
}

class OrderDetails extends React.Component<OrderProps, any> {
  public onCancelOrder = () => {
    const cancelOrderMessage = this.props.intl.formatMessage(messages.cancelOrderMessage);
    const yes = this.props.intl.formatMessage(utilsMessages.yes);
    const no = this.props.intl.formatMessage(utilsMessages.no);
    AModal.confirm({
      autoFocusButton: null,
      okButtonProps: {
        danger: true,
      },
      title: cancelOrderMessage,
      okText: yes,
      cancelText: no,
      onOk: () => {
        const { order } = this.props;
        this.props.onCancelOrder({
          id: order?.id,
        });
      },
    });
  };
  public onDisapproveOrder = () => {
    const declineOrderMessage = translations(messages.declineOrderMessage);
    const yes = translations(utilsMessages.yes);
    const no = translations(utilsMessages.no);
    AModal.confirm({
      autoFocusButton: null,
      okButtonProps: {
        danger: true,
      },
      title: declineOrderMessage,
      okText: yes,
      cancelText: no,
      onOk: () => {
        const { order } = this.props;
        this.props.onDisapproveOrder({
          orderId: order?.id,
        });
      },
    });
  };

  public onApproveOrder = () => {
    const { order } = this.props;
    this.props.onApproveOrder({
      orderId: order?.id,
    });
  };

  public onConfirmOrder = () => {
    const { order } = this.props;
    if (moment(order?.deliveryTime.start).isAfter(new Date())) {
      const yes = translations(utilsMessages.yes);
      const no = translations(utilsMessages.no);
      AModal.confirm({
        autoFocusButton: null,
        title: translations(messages.confirmDeliveryOrderMessage),
        okText: yes,
        cancelText: no,
        onOk: () => {
          const { order } = this.props;
          this.props.onConfirmOrder({
            id: order?.id,
          });
        },
      });
    } else {
      this.props.onConfirmOrder({
        id: order?.id,
      });
    }
  };

  public reOrderAll = () => {
    const { order } = this.props;
    this.props.onReOrderAll({
      storeId: order?.store.id,
      orderId: order?.id,
    });
  };

  public render() {
    const { order, permissions, isStatusChange } = this.props;

    return (
      <>
        <Viewport.Consumer>
          {({ width }) => {
            const isMobileSize = width < 768;
            return (
              <Spin spinning={order?.loading}>
                <Container>
                  <Card style={{ marginBottom: '6pt', backgroundColor: 'white' }} bordered={false}>
                    <LegacyOrderSummary
                      order={order}
                      onCancelOrder={this.onCancelOrder}
                      reOrderAll={this.reOrderAll}
                      onDisapproveOrder={this.onDisapproveOrder}
                      onApproveOrder={this.onApproveOrder}
                      onEditOrder={this.props.onEditOrder}
                      onPrintOrderInvoice={this.props.onPrintOrderInvoice}
                      isMobileSize={isMobileSize}
                      onUpdateDelivery={this.props.onUpdateDelivery}
                      permissions={permissions}
                    />
                  </Card>
                  <Card bordered={false} style={{ borderBottomRightRadius: 0 }} bodyStyle={{ padding: 0 }}>
                    {isMobileSize ? (
                      <TableContainer>
                        <LegacyMobileTable order={order} />
                      </TableContainer>
                    ) : (
                      <LegacyDesktopTable order={order} />
                    )}
                  </Card>
                </Container>
              </Spin>
            );
          }}
        </Viewport.Consumer>
        {isStatusChange && (
          <Suspense fallback={<LoadingIndicator />}>
            <LazyModal
              centered
              style={{ textAlign: 'center', maxWidth: '380px' }}
              open={isStatusChange}
              onOk={() => {
                window.location.reload();
              }}
              okText={translations(utilsMessages.confirm)}
              cancelButtonProps={{ style: { display: 'none' } }}
              closable={false}
              okButtonProps={{ style: { marginLeft: 'auto', marginRight: 'auto', display: 'block' } }}
            >
              {translations(messages.reloadOrderText)}
            </LazyModal>
          </Suspense>
        )}
      </>
    );
  }
}

export default injectIntl(OrderDetails);
